const clearableSearchFieldStyles = {
  button: {padding: "0"},
  searchField: {width: "100%"},
};

export default clearableSearchFieldStyles;
